import axios from "axios";
import ErrorCodes from "@/error-codes";
import EventBus from "@/event-bus";
import { apiBase } from "@/constants";

export default {
  state: {
    addProfileErrors: [],
    balance: 0,
    currentProfileId: 0,
    followers: 0,
    following: 0,
    profiles: [],
    profileToAddInfo: {
      username: '',
      password: '',
      phoneNumber: '',
      twoFactorCode: '',
      verificationCode: '',
      preferSMSVerification: true,
      replayChallenge: false
    }
  },
  getters: {
    addProfileErrors: state => state.addProfileErrors,
    balance: state => state.balance,
    currentProfileId: state => state.currentProfileId,
    profiles: state => state.profiles,
    followers: state => state.profiles[state.currentProfileId].followersCount,
    following: state => state.profiles[state.currentProfileId].followingCount,
    maxProfileId(state) {
      if (state.profiles.length > 0) {
        return state.profiles[state.profiles.length - 1].id;
      }
      return -1;
    },
    profileGuid: state => state.profiles[state.currentProfileId].id,
    profileLogin: state => state.profiles[state.currentProfileId].username,
    profileName: state => state.profiles[state.currentProfileId].profileName,
    profilePicture: state => state.profiles[state.currentProfileId].profilePictureUrl,
    profileToAddInfo: state => state.profileToAddInfo
  },
  mutations: {
    addProfile(state, payload) {
      state.profiles.push(payload);
    },
    clearAddProfileErrors(state) {
      state.addProfileErrors = [];
    },
    clearAddProfileInfo(state) {
      state.addProfileInfo = {
        username: '',
        password: '',
        phoneNumber: '',
        twoFactorCode: '',
        verificationCode: '',
        preferSMSVerification: true,
        replayChallenge: false
      };
    },
    deleteProfile(state, profileGuid) {
      state.profiles = state.profiles.filter(x => x.id !== profileGuid);
    },
    getUsersProfiles(state, profiles) {
      state.profiles = profiles;
    },
    pushAddProfileErrors(state, message) {
      state.addProfileErrors.push(message);
    },
    switchToProfile(state, guid) {
      state.currentProfileId = state.profiles.findIndex(x => x.id === guid);
      EventBus.$emit('profileChanged', guid);
    },
    updateProfileToAddPassword(state, password) {
      state.profileToAddInfo.password = password;
    },
    updateProfileToAddPhoneNumber(state, phoneNumber) {
      state.profileToAddInfo.phoneNumber = phoneNumber;
    },
    updateProfileToAddTwoFactorCode(state, twoFactorCode) {
      state.profileToAddInfo.twoFactorCode = twoFactorCode;
    },
    updateProfileToAddUsername(state, username) {
      state.profileToAddInfo.username = username;
    },
    updateProfileToAddVerificationCode(state, verificationCode) {
      state.profileToAddInfo.verificationCode = verificationCode;
    }
  },
  actions: {
    addProfile({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('showLoadingModal', false);
        commit('clearAddProfileErrors');
        axios.post(`${apiBase}/instagramaccount`, state.profileToAddInfo)
          .then((response) => {
            if (response.status !== 200) {
              return;
            }

            commit('hideModal');
            commit('clearAddProfileInfo');
            commit('addProfile', response.data);
            resolve(response);
          })
          .catch((err) => {
            if (!err.response) {
              return;
            }

            const { code } = err.response.data;
            if (code === ErrorCodes.userNotFound) {
              commit("pushAddProfileErrors", "Podany profil nie istnieje.");
              commit("showModal", "AddProfileModal");
            } else if (code === ErrorCodes.accountAlreadyExists) {
              commit("pushAddProfileErrors", "Podany profil jest już przypisany do innego konta.");
              commit("showModal", "AddProfileModal");
            } else if (code === ErrorCodes.twoFactorRequired) {
              if (state.profileToAddInfo.twoFactorCode) {
                commit("pushAddProfileErrors", "Podany kod jest nieprawidłowy.");
              }
              commit("showModal", "ProfileTwoFactorCodeModal");
            } else if (code === ErrorCodes.verificationCodeRequired) {
              if (state.profileToAddInfo.verificationCode) {
                commit("pushAddProfileErrors", "Podany kod jest nieprawidłowy.");
              }
              commit("showModal", "ProfileVerificationCodeModal");
            } else if (code === ErrorCodes.invalidCredentials) {
              commit("pushAddProfileErrors", "Podane hasło jest nieprawidłowe!");
              commit("showModal", "AddProfileModal");
            } else if (code === ErrorCodes.unknownError) {
              reject(err.response);
            }
          });
      });
    },
    deleteProfile({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        axios.delete(`${apiBase}/instagramaccount/${getters.profileGuid}`)
          .then((response) => {
            commit('hideModal');

            if (!response || response.status !== 200) {
              reject(response);
              return;
            }

            const newProfileId = (state.currentProfileId + 1) % state.profiles.length;
            commit('switchToProfile', state.profiles[newProfileId].id);
            commit('deleteProfile', getters.profileGuid);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUsersProfiles({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`${apiBase}/instagramaccount/current`)
          .then((response) => {
            if (response.status === 200) {
              commit('getUsersProfiles', response.data);
              resolve(response);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    switchProfile({ commit }, profileGuid) {
      return new Promise((resolve) => {
        commit('switchToProfile', profileGuid);
        resolve();
      });
    }
  }
};
